const $ = jQuery.noConflict();

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MegaMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find(
			'> #menu-main-nav > .menu-item-type-post_type'
		);
		this.menuItemsLinks = this.menuItems.find('> a');

		this.mobMenu = $('.main-header__nav-mobile');
		this.mobMenuItems = this.mobMenu.find(
			'> #menu-mobile-main-nav > .menu-item-type-post_type'
		);
		this.mobMenuItemsLinks = this.mobMenuItems.find('> a');
		this.search = $('.btn-search');
		this.menuBackground = $('.mega-menu-background');
	}
	toggleDestopMegaMenu(e) {
		e.preventDefault();
		const megaMenuWrapper = $(this).next('.mega-menu-wrapper');
		if (!megaMenuWrapper.hasClass('active')) {
			MegaMenu.hideSearchBar();
			MegaMenu.hideMegaMenu();
			MegaMenu.showMegaMenu($(this).closest('.menu-item-type-post_type'));
		} else {
			MegaMenu.hideMegaMenu();
		}
	}
	static showMegaMenu(item) {
		const megaMenuWrapper = item.find('.mega-menu-wrapper');

		item.closest('.main-header__nav').addClass('open');
		item.closest('.menu-item').addClass('active');

		megaMenuWrapper.addClass('active');
		MegaMenu.animateMenuBackground(true);
	}
	static hideMegaMenu() {
		//clearTimeout(MegaMenu.menuTimeout);
		const activeMegaMenu = $('.mega-menu-wrapper.active');
		const activeMegaMenuItems = activeMegaMenu.find('*');
		$('.menu-item').removeClass('active');
		$('.main-header__nav').removeClass('open');
		activeMegaMenu.removeClass('active');
		activeMegaMenuItems.removeClass('active');
		$('.mega-menu-wrapper .main-header__cta-wrapper--mobile a').removeClass(
			'active'
		);

		MegaMenu.animateMenuBackground(false);
	}
	toggleSearchBar(e) {
		e.preventDefault();
		if (!$('.search-wrapper').hasClass('active')) {
			if (
				$(window).width() < 1200 &&
				$('.btn-hamburger').hasClass('open')
			) {
				$('.btn-hamburger').trigger('click');
			}
			MegaMenu.activeSearchBar();
			$(this).addClass('open');
		} else {
			MegaMenu.hideSearchBar();
			$(this).removeClass('open');
		}
	}
	static activeSearchBar() {
		MegaMenu.hideMegaMenu();
		$('.search-wrapper').addClass('active');
		MegaMenu.animateMenuBackground(true);
	}
	static hideSearchBar() {
		$('.search-wrapper').removeClass('active');
		MegaMenu.animateMenuBackground(false);
	}
	static hideMegaMenuOnTouch(e) {
		const container = $('.main-header__nav-mobile');
		if (
			!container.is(e.target) &&
			container.has(e.target).length === 0 &&
			$('.mega-menu-wrapper').hasClass('active')
		) {
			MegaMenu.hideMegaMenu();
		}
	}
	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.04;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}
	static animateMenuBackground(state) {
		if (state) {
			$('.mega-menu-background').addClass('active');
		} else {
			$('.mega-menu-background').removeClass('active');
		}
	}
	bindEvents() {
		if (isTouchDevice() || $(window).width() < 1200) {
			this.bindMobileEvents();
			this.mobMenuItemsLinks.on('click', this.toggleMegaMenu);
			$(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
		} else {
			// On menu link click, show or hide menu
			this.menuItemsLinks.on('click', this.toggleDestopMegaMenu);
			// On bg click, hide Search/existing menu
			this.menuBackground.on('click', function () {
				MegaMenu.hideSearchBar();
				MegaMenu.hideMegaMenu();
			});
			// On link hover, hide Search/existing menu, show new menu
			this.menuItemsLinks.on('mouseover', function () {
				MegaMenu.hideSearchBar();
				MegaMenu.hideMegaMenu();
				MegaMenu.showMegaMenu(
					$(this).closest('.menu-item-type-post_type')
				);
			});
			$('.main-header__nav').on('mouseleave', MegaMenu.hideMegaMenu);
		}
		this.search.on('click', this.toggleSearchBar);
	}
	bindMobileEvents() {
		const mobileMenu = $('.main-header__nav-mobile');
		const mobileMenuItems = mobileMenu.find('> .menu > li');
		const ctaBtn = $('.main-header__cta-wrapper--mobile').clone();
		mobileMenuItems.find('.mega-menu-wrapper').append(ctaBtn);

		mobileMenuItems.each(function () {
			const menuLabel = $(this).find('> a').text();
			const subMenu = $(this).find(
				'> .mega-menu-wrapper > .container > .row'
			);
			if (subMenu.length > 0) {
				const headLi =
					'<div class="col-sm-12"><div class="menu-mobile-action"><a class="backBtn" href="#">Back</a><span>' +
					menuLabel +
					'</span></div></div>';
				subMenu.prepend(headLi);
			}
		});
		this.bindBackEvents();
	}
	bindBackEvents() {
		$('.backBtn').on('click', function (e) {
			e.preventDefault();
			MegaMenu.hideMegaMenu();
		});
	}
	sticky() {
		$(window).scroll(function () {
			const scroll = $(window).scrollTop();

			if (scroll >= 20) {
				$('.main-header').addClass('sticky');
			} else {
				$('.main-header').removeClass('sticky');
			}
		});
	}
	toggleMegaMenu(e) {
		e.preventDefault();
		MegaMenu.hideMegaMenu();
		MegaMenu.hideSearchBar();
		const megaMenuWrapper = $(this).next('.mega-menu-wrapper');

		if (megaMenuWrapper.hasClass('active')) {
			return;
		}

		megaMenuWrapper.addClass('active');
		megaMenuWrapper
			.find('.main-header__cta-wrapper--mobile a')
			.addClass('active');
		MegaMenu.animateMenuBackground(true);
	}
	init() {
		this.bindEvents();
		this.sticky();
	}
}
export default new MegaMenu();
